import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import albergoEticoImage from '../assets/rhr-albergo-etico.png';
import eticoFoodImage from '../assets/rhr-food-etico.png';
import logoOmar from '../assets/logo_omar.png';
import logoAmr from '../assets/logo_amr.jpg';
import logoAig from '../assets/logo_aig.png';
import logoAiri from '../assets/logo_airi.png';
import logoAsimas from '../assets/logo_asimas.png';
import logoEticaAssicurativa from '../assets/logo_etica_assicurativa.png';
import logoBcs from '../assets/Logo BCS.png';
import logoFrameAcademy from '../assets/Logo_Frame_Academy_360.png';
const Partners = () => {
  // Mock data for partners - in a real application, this would come from an API or CMS
  const partners = [
    {
      id: 1,
      name: 'Osservatorio Malattie Rare',
      logo: logoOmar,
      website: 'https://www.osservatoriomalattierare.it/'
    },
    {
      id: 2,
      name: 'Alleanza Malattie Rare',
      logo: logoAmr,
      website: 'https://www.osservatoriomalattierare.it/alleanza-malattie-rare'
    },
    {
      id: 3,
      name: 'Associazione Italiana Gaucher',
      logo: logoAig,
      website: 'https://www.gaucheritalia.org/'
    },
    {
      id: 4,
      name: 'Associazione Italiana per la Ricerca sulle Istiocitosi',
      logo: logoAiri,
      website: 'https://www.istiocitosi.org/'
    },
    {
      id: 5,
      name: 'Associazione Italiana Mastocitosi',
      logo: logoAsimas,
      website: 'https://www.asimas.it/new_asimas/'
    },
    {
      id: 6,
      name: 'Albergo Etico',
      logo: albergoEticoImage,
      website: 'https://www.albergoetico.it'
    },
    {
      id: 7,
      name: 'Etico Food',
      logo: eticoFoodImage,
      website: 'https://www.eticofood.com'
    },
    {
      id: 8,
      name: 'Etica Assicurativa',
      logo: logoEticaAssicurativa,
      website: 'https://www.eticaassicurativa.it/'
    },
    {
      id: 9,
      name: 'Borrello Centro Servizi',
      logo: logoBcs,
      website: 'https://borrello.info'
    },
    {
      id: 10,
      name: 'Frame Academy 360',
      logo: logoFrameAcademy,
      website: 'https://www.frameacademy360.com/'
    }
  ];

  // Effetto di animazione al caricamento
  const animatedItemsRef = useRef([]);
  
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = animatedItemsRef.current;
    elements.forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => {
      elements.forEach((el) => {
        if (el) observer.unobserve(el);
      });
    };
  }, []);

  // Funzione per aggiungere elementi all'array di riferimenti
  const addToRefs = (el) => {
    if (el && !animatedItemsRef.current.includes(el)) {
      animatedItemsRef.current.push(el);
    }
  };

  return (
    <>
      <style jsx="true">{`
        .animate-on-scroll {
          opacity: 0;
          transform: translateY(30px);
          transition: opacity 0.8s ease-out, transform 0.8s ease-out;
        }
        .animate-in {
          opacity: 1;
          transform: translateY(0);
        }
        .geometric-bg {
          position: relative;
          overflow: hidden;
        }
        .geometric-bg::before, .geometric-bg::after {
          content: '';
          position: absolute;
          z-index: 0;
          border-radius: 50%;
          animation: float 8s infinite ease-in-out;
        }
        .geometric-bg::before {
          width: 200px;
          height: 200px;
          top: -50px;
          right: -50px;
          opacity: 0.1;
        }
        .geometric-bg::after {
          width: 150px;
          height: 150px;
          bottom: -50px;
          left: -50px;
          opacity: 0.1;
          animation-delay: 2s;
        }
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-20px); }
        }
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
        .partner-item:hover .partner-shape {
          transform: scale(1.1) rotate(5deg);
        }
        .partner-shape {
          transition: transform 0.3s ease-in-out;
          width: 120px;
          height: 120px;
          object-fit: contain;
          border-radius: 8px;
        }
      `}</style>
      <div className="geometric-bg py-12 relative overflow-hidden">
        <div className="container mx-auto px-4 relative z-10">
          <h1 className="text-4xl md:text-5xl font-bold text-center text-primary mb-4 animate-on-scroll animate-in" ref={addToRefs}>I Nostri Partners</h1>
          <p className="text-xl text-center text-gray-700 max-w-3xl mx-auto mb-12 animate-on-scroll" ref={addToRefs} style={{animationDelay: '0.2s'}}>
            Robin Hood Roma ODV collabora con partner selezionati per migliorare l'impatto sociale e promuovere l'inclusione nella nostra comunità, la conoscenza sulle malattie rare.
          </p>

          {/* Partners Section */}
          <section className="mb-20 animate-on-scroll" ref={addToRefs}>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
              {partners.map((partner, index) => (
                <div 
                  key={partner.id} 
                  className="partner-item bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 hover:shadow-2xl hover:scale-105 animate-on-scroll min-h-[300px]" 
                  ref={addToRefs}
                  style={{animationDelay: `${0.1 * (index + 1)}s`}}
                >
                  <div className="p-6 h-full flex flex-col">
                    <div className="flex-grow flex flex-col items-center">
                      <div className="flex justify-center mb-4">
                        <img 
                          src={partner.logo}
                          alt={partner.name}
                          className="partner-shape"
                        />
                      </div>
                      <h3 className="text-2xl font-bold text-center text-primary mb-3">{partner.name}</h3>
                    </div>
                    <div className="mt-auto text-center">
                      <a 
                        href={partner.website} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="group px-6 py-3 bg-primary hover:bg-primary/90 text-white font-bold rounded-lg shadow-md hover:shadow-lg inline-flex items-center space-x-2 hover:-translate-y-1 transition-all duration-300"
                      >
                        <span>Visita il sito</span>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
          
          {/* Call to Action Section */}
          <section className="mb-12 animate-on-scroll" ref={addToRefs}>
            <div className="bg-gradient-to-r from-primary via-accent to-accent text-white rounded-xl shadow-2xl overflow-hidden relative py-12 px-6 text-center">
              {/* Decorative elements */}
              <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
                <div className="absolute -top-12 -left-12 w-64 h-64 rounded-full bg-white opacity-10 animate-pulse"></div>
                <div className="absolute top-40 -right-16 w-48 h-48 rounded-full bg-white opacity-10" style={{animation: 'float 8s infinite ease-in-out'}}></div>
                <div className="absolute bottom-0 left-1/4 w-32 h-32 rounded-full bg-white opacity-10 animate-pulse" style={{animationDelay: '1s'}}></div>
              </div>
              
              <h2 className="text-3xl md:text-4xl font-bold mb-6 relative" style={{animation: 'slideUp 0.5s ease-out forwards'}}>Collabora con Noi</h2>
              <p className="text-xl mb-8 max-w-2xl mx-auto relative" style={{animation: 'slideUp 0.5s ease-out forwards', animationDelay: '200ms'}}>
                La tua organizzazione può fare la differenza nella vita dei pazienti con malattie ematologiche rare. Diventa partner di Robin Hood Roma ODV per un futuro migliore.
              </p>
              <div className="flex flex-col sm:flex-row justify-center gap-4 relative z-10">
                <a 
                  href="/contatti" 
                  className="group bg-white font-bold py-3 px-8 rounded-full shadow-lg transition-all duration-300 transform hover:translate-y-[-5px] hover:shadow-xl hover:scale-105 relative overflow-hidden"
                >
                  <span className="relative z-10 bg-gradient-to-r from-primary to-accent inline-block text-transparent bg-clip-text font-bold transition-all duration-300 group-hover:opacity-90">Diventa Partner</span>
                  <span className="absolute bottom-0 left-0 w-full h-[2px] bg-gradient-to-r from-primary to-accent transform origin-left scale-x-0 transition-transform duration-300 group-hover:scale-x-100"></span>
                </a>
                <a 
                  href="/sostienici" 
                  className="group bg-transparent border-2 border-white text-white font-bold py-3 px-8 rounded-full shadow-lg transition-all duration-300 transform hover:bg-white hover:text-accent hover:border-transparent hover:translate-y-[-5px] hover:shadow-xl"
                >
                  <span className="relative z-10">Effettua una Donazione</span>
                </a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default Partners;

